import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.options.xhr = { withCredentials: true }

Vue.http.interceptors.push((request, next) => {
	// localhost:6080   need set jwt
	// request.headers.set('jwt', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjEyNzkwMCwiaXNzIjoiaHR0cDovL29yZGVyLnF0ZXN0LmRhb2hlaHVpLmNvbS9xeWgvbG9naW4iLCJpYXQiOjE2MzkzNjEzNjUsImV4cCI6MTYzOTM5NzM2NSwibmJmIjoxNjM5MzYxMzY1LCJqdGkiOiJ3NDhSZ2RRVzY4UHdsTDVXIn0.3ErAyJynN4sGjRvGKDnn7FUMZhHNO7tBqNIybnmnS1Q')

	console.log('request: ', request)
	// modify method
	// request.method = 'POST';
	// request.headers.set('Authorization', 'Bearer TOKEN');
	// continue to next interceptor
	next()
})

Vue.prototype.SignContract = function (order, cb) {
	if (order.has_survey === false) {
		this.toast('请您先填写问卷')
		return
	}
	if (order.has_signed === true) {
		this.toast('您已签订合同')
	} else {
		let url = '/api/orders/contracts/' + order.order_no
		this.loading('正在创建电子合同, 请稍候')
		this.$http.post(url, {timeout: 30000}).then(response => {
			console.log(response)
			var rs = response.body
			if (rs.code === 0) {
				if (rs.data.sign_url) {
					// 跳转去签订合同
					window.location.href = rs.data.sign_url
					this.loadingHide()
				} else {
					this.loadingHide()
					cb && cb(rs)
				}
			} else {
				this.handleHttpError(response)
			}
		}, response => {
			console.log(response)
			this.handleHttpError(response)
		})
		//
		let self = this
		let it = null
		it = setTimeout(function () {
			self.loadingHide()
			self.toast('请刷新本页后重试')
			if (it) {
				clearTimeout(it)
			}
		}, 30000)
	}
}

Vue.prototype.PostSurvey = function (order, cb) {
	if (order.has_survey === true) {
		this.toast('您已填写问卷, 请签订合同')
		window.location.href = '?#/my/orders'
	} else {
		let url = '/api/customers/survey/' + order.order_no
		this.loading('请稍候')
		this.$http.get(url, {timeout: 30000}).then(response => {
			this.loadingHide()
			// console.log(response)
			var rs = response.body
			if (rs.code === 0) {
				if (rs.data.has_survey === true) {
					cb && cb(rs)
				} else {
					let form = document.getElementById('jumpFormDiv')
					form.innerHTML = rs.data.jump_form
					document.getElementsByName('jumpForm')[0].submit()
				}
			} else {
				this.handleHttpError(response)
			}
		}, response => {
			console.log(response)
			this.handleHttpError(response)
		})
		//
		let self = this
		let it = null
		it = setTimeout(function () {
			self.loadingHide()
			self.toast('请刷新本页后重试')
			if (it) {
				clearTimeout(it)
			}
		}, 30000)
	}
}

Vue.prototype.getOrderSimpleDetail = function (orderNo, cb = () => {}) {
	let url = '/api/orders/simple/' + orderNo
	this.$http.get(url).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		if (rs.code === 0) {
			this.$store.dispatch('setOrder', {'order': rs.data.order})
			cb(rs.data.order)
		} else {
			this.handleHttpError(response)
		}
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}

Vue.prototype.getOrderFullDetail = function (orderNo, tag, cb) {
	let qs = window.location.href.split('#')[0]
	let url = '/api/orders/' + orderNo + '?tag=' + tag + '&_qs_=' + encodeURIComponent(qs)
	this.$http.get(url).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		if (rs.code === 0) {
			this.$store.dispatch('setOrder', {'order': rs.data.order})
			cb(rs)
		} else {
			this.handleHttpError(response)
		}
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}
Vue.prototype.fetchPayChannels = function (cb) {
	let url = '/api/integration/pay/channels'
	this.$http.get(url).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		if (rs.code === 0) {
			this.$store.dispatch('setPayChannels', {'items': rs.data})
			cb && cb(rs.data)
		} else {
			this.handleHttpError(response)
		}
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}
Vue.prototype.getMessageDetail = function (msgId, tag, cb) {
	let url = '/api/messages/detail/' + msgId + '?tag=' + tag
	this.$http.get(url).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		if (rs.code === 0) {
			cb && cb(rs.data)
		} else {
			this.handleHttpError(response)
		}
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}
Vue.prototype.rememberOrder = function (orderNo, tag, cb) {
	let url = '/api/customers/do/' + orderNo + '?tag=' + tag
	this.$http.put(url).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		if (rs.code === 0) {
			cb && cb(rs.data)
		} else {
			this.handleHttpError(response)
		}
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}
Vue.prototype.sendSmsCode = function (mobile, orderNo, channel, cb) {
	let url = '/api/sms/code'
	this.$http.post(url, {'mobile': mobile, 'order_no': orderNo, 'channel': channel}).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		if (rs.code === 0) {
			cb && cb(rs)
		} else {
			cb && cb(rs)
		}
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}

Vue.prototype.verifySmsCode = function (mobile, orderNo, smsCode, channel, cb) {
	let url = '/api/sms/verify'
	this.$http.post(url, {'mobile': mobile, 'order_no': orderNo, 'sms_code': smsCode, 'channel': channel}).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		if (rs.code === 0) {
			cb && cb(rs)
		} else {
			cb && cb(rs)
		}
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}

Vue.prototype.createOneKeyOrder = function (orderNo, cb) {
	let url = '/api/onekey/order'
	this.$http.post(url, {'orderNo': orderNo}).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		rs.code === 0 ? cb && cb(rs) : cb && cb(rs)
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}

Vue.prototype.getOneKeyPayWay = function (orderNo, cb) {
	console.log('PureDebugOrderNo:', orderNo)
	let url = '/api/payment/onekey/' + orderNo
	this.$http.get(url).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		rs.code === 0 ? cb && cb(rs) : cb && cb(rs)
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}

Vue.prototype.getCouponList = function (orderNo, cb) {
	console.log('CouponListNo:', orderNo)
	let url = '/api/coupons/' + orderNo
	this.$http.get(url).then(response => {
		this.loadingHide()
		console.log(response)
		var rs = response.body
		rs.code === 0 ? cb && cb(rs) : cb && cb(rs)
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}

Vue.prototype.getQrCode = function (orderNo, cb) {
	let url = '/api/wechat/qrCode?order_no=' + orderNo
	this.$http.get(url).then(response => {
		this.loadingHide()
		var rs = response.body
		rs.code === 0 ? cb && cb(rs) : cb && cb(rs)
	}, response => {
		console.log(response)
		this.handleHttpError(response)
	})
}



// WEBPACK FOOTER //
// ./src/http/index.js